import React from 'react';

import Input from 'antd/es/input';
import Button from 'antd/es/button';
import Form from 'antd/es/form';

const ChangePasswordForm = ({ onSubmit, isLoading }) => (
  <Form
    layout="vertical"
    onFinish={onSubmit}
    style={{ width: '360px' }}
    hideRequiredMark={true}
  > 
    <Form.Item
      name="currentPassword"
      label="Current password"
      rules={[
        {
          required: true,
          message: 'Please enter your current password',
        },
      ]}
    >
      <Input.Password
        type="password"
        placeholder="Enter current password"
      />
    </Form.Item>
    <Form.Item
      name="newPassword"
      label="New password"
      rules={[
        {
          required: true,
          message: 'Please enter your new password',
        },
      ]}
    >
      <Input.Password
        type="password"
        placeholder="Enter new password"
      />
    </Form.Item>

    <Form.Item>
      <Button type="primary" htmlType="submit" style={{ width: '100%' }} loading={isLoading} disabled={isLoading} size="large">
        Save Changes
      </Button>
    </Form.Item>
  </Form>    
);

export default ChangePasswordForm;
